import {get, setAccessToken} from "@/lib/fetcher";

export default {
    namespaced: true,
    state: () => ({
        webAppState: {
            //Decode base64 json
            useCollectorContest: false,
            payload: {},
            playerCode: "",
            playerName: "",
            currentContract: {
                level: null,
                suit: null,
                dbl: null,
                declarer: null,
                tricks: null,
                leadRank: null,
                leadSuit: null
            },
            currentBoard: null
        },
        configurations: {
        },

        //clientConfigurations region
        showTotalTricks: JSON.parse(localStorage.getItem("showTotalTricks")) || false,
        showByTeam: JSON.parse(localStorage.getItem("showByTeam")) || false
    }),
    mutations: {
        changeCurrentContract(state, newContract) {
            Object.keys(state.webAppState.currentContract).forEach(key => {
                if (newContract[key] !== undefined) {
                    state.webAppState.currentContract[key] = newContract[key];
                }
            });
        },
        changeCurrentBoard(state, newBoard) {
            state.webAppState.currentBoard = newBoard;
        },
        changeShowTotalTricks(state, newValue) {
            state.showTotalTricks = newValue;
            localStorage.setItem("showTotalTricks", newValue);
        },
        changeShowByTeam(state, newValue) {
            state.showByTeam = newValue;
            localStorage.setItem("showByTeam", newValue);
        },
        changeConfigurations(state, newConf) {
            state.configurations = newConf;
        },
        changePayload(state, newPayload) {
            state.webAppState.payload = newPayload;
        },
        changePlayerCode(state, newPlayerCode) {
            state.webAppState.playerCode = newPlayerCode;
        },
        changePlayerName(state, newPlayerName) {
            state.webAppState.playerName = newPlayerName;
        },
        changeContext(state, useCollectorContest) {
            state.webAppState.useCollectorContest = useCollectorContest;
        }
    },
    actions: {
        changeCurrentContract({commit}, newContract) {
            commit('changeCurrentContract', newContract);
        },
        changeCurrentBoard({commit}, newBoard) {
            commit('changeCurrentBoard', newBoard);
        },
        changeShowTotalTricks({commit}, newValue) {
            commit('changeShowTotalTricks', newValue);
        },
        changeShowByTeam({commit}, newValue) {
            commit('changeShowByTeam', newValue);
        },
        loadConfigurations({commit}) {
            get('/api/tournament/configurations')
                .then(resp => {
                    commit('changeConfigurations', resp);
                });
        },
        changePayload({commit}, newPayload) {
            let payload = JSON.parse(atob(newPayload.local_access_token.split('.')[1]));
            const playerCode = payload.figbCode;
            const playerName = payload.name;
            commit('changePayload', newPayload)
            commit('changePlayerCode', playerCode)
            commit('changePlayerName', playerName)
        },
        changeContext({commit, state}, useCollectorContext) {
            commit('changeContext', useCollectorContext)

            const currentToken = useCollectorContext ? state.webAppState.payload.collector_access_token : state.webAppState.payload.local_access_token;
            setAccessToken(currentToken);
        }
    },
    getters: {
        currentToken: state => state.webAppState.useCollectorContest ? state.webAppState.payload.collector_access_token : state.webAppState.payload.local_access_token,
        currentContract: state => state.webAppState.currentContract,
        currentBoard: state => state.webAppState.currentBoard,
        playerCode: state => state.webAppState.playerCode,
        playerName: state => state.webAppState.playerName,
        configurations: state => state.configurations,
        useCollectorContest: state => state.webAppState.useCollectorContest,
        hasCollectorContest: state => state.webAppState.payload.collector_access_token !== "" && state.webAppState.payload.collector_access_token != null,
        showTotalTricks: state => state.showTotalTricks,
        showByTeam: state => state.showByTeam,
        isTd: (state, getters, rootState, rootGetters) => {
            const tdCodes = rootGetters['tournament/directors'];
            const playerCode = rootGetters['webApp/playerCode'];

            if (tdCodes == null) {
                return false;
            }
            return tdCodes.find(plr => plr.Code === playerCode) !== undefined;
        },
        isPlaying: (state, getters, rootState, rootGetters) => {
            const playerCode = rootGetters['webApp/playerCode'];
            const players = {...rootGetters['players/playersList'], ...rootGetters['players/teamPlayers']};

            return Object.values(players).find(plr => plr?.Code === playerCode) !== undefined;
        },
        isVisitor: (state, getters, rootState, rootGetters) => {
            const playerCode = rootGetters['webApp/playerCode'];
            return playerCode === "VISITOR";
        }
    }
};
